import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSelect from "src/components/LanguageSelect/LanguageSelect";
import { APP_INFO } from "src/config/appInfo";
import "./login.scss";
import "./loginForm.scss";

export default function ForgotPassword() {
    const { t } = useTranslation();
    const [praxis, setPraxis] = useState("");
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = async () => {
        setError("");
        if (!praxis.trim() || !email.trim()) return;
        setLoading(true);
        try {
            const res = await fetch("/api/forgot-password", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ praxisId: praxis.trim(), email: email.trim() }),
            });
            if (res.ok) {
                setSent(true);
            } else {
                setError(t("login.invalidCredentials"));
            }
        } catch {
            setError(t("login.invalidCredentials"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-card-wrapper">
                <div className="login-card">
                    <LanguageSelect />
                    <div className="login-header">
                        <div className="login-logo">
                            <img src="/medinvoice-logo.png" alt={APP_INFO.appName} className="login-brand-logo" />
                        </div>
                        <div className="login-title">{t("login.forgotPasswordTitle")}</div>
                        <div className="login-subtitle">{t("login.forgotPasswordSubtitle")}</div>
                    </div>

                    {sent ? (
                        <div className="forgot-password-sent">
                            {t("login.forgotPasswordSent")}
                        </div>
                    ) : (
                        <form onSubmit={(e) => e.preventDefault()}>
                            <div className="form-group">
                                <label htmlFor="fp-praxis">{t("login.praxisId")}</label>
                                <input
                                    id="fp-praxis"
                                    type="text"
                                    placeholder={t("login.praxisIdPlaceholder")}
                                    value={praxis}
                                    onChange={(e) => setPraxis(e.target.value)}
                                    onKeyUp={(e) => e.key === "Enter" && handleSubmit()}
                                    autoFocus
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="fp-email">{t("login.email")}</label>
                                <input
                                    id="fp-email"
                                    type="email"
                                    placeholder={t("login.emailPlaceholder")}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    onKeyUp={(e) => e.key === "Enter" && handleSubmit()}
                                />
                            </div>
                            <div className="login-error">{error}</div>
                            <button
                                type="button"
                                className="btn-primary"
                                onClick={handleSubmit}
                                disabled={loading || !praxis.trim() || !email.trim()}
                            >
                                {loading ? <span className="btn-spinner" /> : t("login.forgotPasswordSend")}
                            </button>
                        </form>
                    )}

                    <div className="login-register">
                        <Link to="/login" className="login-contact-link">
                            {t("login.forgotPasswordBack")}
                        </Link>
                    </div>
                </div>
            </div>

            <div className="login-art">
                <div className="login-art__stage">
                    <div className="login-art__blob" />
                    <div className="login-art__panel login-art__panel--visible"
                         style={{ backgroundImage: "url(/poster_1.webp)" }} />
                </div>
            </div>
        </div>
    );
}
